import React from 'react';
import clsx from 'clsx';
import { FormControl, Grid, TextField, makeStyles, InputAdornment, InputLabel, OutlinedInput, IconButton, Button } from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { login } from '../../store/auth'
import { useDispatch, useSelector } from "react-redux";
import { Link } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
      width: '25ch',
    },
  },
  spacing: {
    marginBottom: '12px' 
  },
  userInput: {
    width: '80%',
    backgroundColor: 'white',
  },
  userButtons: {
    width: '80%',
    marginTop: '5px'
  }
}));

const Login = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const loginError = useSelector(state => state.entities.auth.loginError)
  const [values, setValues] = React.useState({
    email: '',
    password: '',
    showPassword: false,
  });

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  // NOTE // login, and then switch to the flights page
  const handleLogin = () => {
    dispatch(login(values.email, values.password));
  }

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <Grid container style={{marginTop: '15%'}} justify="center">
      <Grid container style={{minWidth: '30vmax', maxWidth: '30vmax', padding: '10px 10px 10px 10px', border: '2px solid gray', borderRadius: '15px'}}>
        <Grid item xs={12}>
          <TextField
            label="Email"
            // id="outlined-basic"
            className={clsx(classes.margin, classes.spacing, classes.userInput)}
            variant="outlined"
            value={values.email}
            onChange={handleChange('email')}
          />
        </Grid>
        <Grid item xs={12}>
          <FormControl className={clsx(classes.margin, classes.textField, classes.spacing, classes.userInput)} variant="outlined">
            <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
            <OutlinedInput
              id="outlined-adornment-password"
              type={values.showPassword ? 'text' : 'password'}
              value={values.password}
              onChange={handleChange('password')}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {values.showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
              labelWidth={70}
            />
          </FormControl>
        </Grid>
        <Grid container justify="center">
          <Grid container item xs={6} justify="center" className={classes.userButtons}>
            <Button variant="contained" size="small" color="primary" onClick={handleLogin}>Submit</Button>
          </Grid>
        </Grid>
        <Grid container justify="center">
          <Grid container item xs={12} justify="center" className={classes.userButtons}>
            <Link to={`/forgot-password`}>Forgot Password</Link>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <p style={{color:'red'}}>{loginError ? 'Incorrect email or password' : ''}</p>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Login